import { printAsciiCIText } from '@devsisters/console-easter-egg';
import * as React from 'react';

export function useEasterEgg(extraMessages: string[] = []) {
  React.useEffect(() => {
    printAsciiCIText(extraMessages);
  }, []);
}
